
// Import the core angular services.
import { ChangeDetectionStrategy, Input, OnInit, ComponentFactoryResolver, ViewChild } from "@angular/core";
import { Component } from "@angular/core";
import { EventEmitter } from "@angular/core";


@Component({
	selector: "app-empty",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ["./empty.component.scss"],
	templateUrl: './empty.component.html',
})
export class EmptyComponent implements OnInit {
	ngOnInit() {
	
	}


}
